// extracted by mini-css-extract-plugin
export default {"box__review":"style_box__review__dR7c-","header__box":"style_header__box__q4jjV","box__title":"style_box__title__Fp1ph","body__box":"style_body__box__oz4G-"};